import React, { Component } from 'react'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class EquipmentItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultName: this.props.equipment.name,
      defaultBody: this.props.equipment.body,
      name: this.props.equipment.name,
      body: this.props.equipment.body
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { equipment } = this.props
    const { edit, name, body } = this.state
    if (
      equipment.name !== nextProps.equipment.name ||
      equipment.body !== nextProps.equipment.body ||
      edit !== nextState.edit ||
      name !== nextState.name ||
      body !== nextState.body
    ) {
      return true
    } else {
      return false
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    const res = window.confirm(deleteMsg)
    if (res) {
      console.log('delete equipment id: ', this.props.equipment.id)
      // const { category, id } = this.props.match.params
      // console.log('category: ', category)
      // console.log('id: ', id)
      // const redirect = function () {
      //   this.props.history.replace(`/${category}`)
      // }
      this.props.deleteData(this.props.equipment.id)
      // this.props.deleteDetails(category, id, redirect.bind(this))
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      body: this.state.defaultBody
    })
  }
  _handleSaveClick () {
    console.log('saving data...')
    const { name, body } = this.state
    const data = {
      equipment_id: this.props.equipment.id,
      name,
      body
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderEquipmentName () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.name} onChange={this._handleUpdateContent.bind(this, 'name')}></textarea>
    }
    return (
      <div className="equipment_value value">{this.state.name}</div>
    )
  }
  _renderEquipmentBody () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.body} onChange={this._handleUpdateContent.bind(this, 'body')}></textarea>
    }
    return (
      <div className="equipment_value value">{this.state.body}</div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="equipment">
        <div className="equipment_inner admin_inner flex column">
          <div className="contents flex top_label">
            <div className="equipment_label label">設備名</div>
            { this._renderEquipmentName()}
          </div>
          <div className="contents flex bottom_label">
            <div className="equipment_label label">設備説明</div>
            { this._renderEquipmentBody()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default EquipmentItem



// WEBPACK FOOTER //
// ./src/components/Properties/Equipments/EquipmentItem.js